/** @jsx jsx */
import React, { useEffect } from "react";
import { css, jsx } from "@emotion/core";
import { Row, Col } from "react-grid-system";
import FlexBox from "components/atoms/FlexBox";
import CalendarForm from "components/molecules/CalendarForm";
import FormPadding from "components/atoms/Form/FormPadding";
import BodyText from "components/atoms/BodyText";
// import VerticalLabelSelectFormV2 from "components/molecules/VerticalLabelSelectFormV2";
import PrimaryButton, { SecondaryButton } from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import ClickableIconButton from "components/atoms/ClickableIconButton";
import { useDailyShiftContext } from "./contextHook";
import moment from "moment";
import Checkbox from "components/molecules/Checkbox";
import SelectForm from "components/molecules/SelectForm";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import Calendar from "components/molecules/CalendarV1";

const Filters: React.FC = () => {
  const {
    setOpenConfirmModal,
    dailyShift,
    loadEmploymentDone,
    filters: {
      orgs,
      dateFromStr,
      setDateFromStr,
      isAttendExists,
      setAttendExists,
      selectedOrg,
      setSelectedOrg,
      employmentOptions,
      setEmploymentOptions,
      downloadPdf,
      checkall,
      setCheckall,
    }
  } = useDailyShiftContext();

  useEffect(() => {
    if (employmentOptions !== null && employmentOptions !== [] && loadEmploymentDone) {
      let sessionData = '';
      let list = employmentOptions.reduce((x: any, y: any) => {
        return y.checked === true ? [...x, y.value] : x;
      }, []);
      if (list.length === employmentOptions.length) {
        sessionData = 'all';
        setCheckall(true);
      } else {
        sessionData = list.join();
        setCheckall(false);
      }
      sessionStorage.setItem(`0/sessionData${window.location.pathname}.employmentOptions`, sessionData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employmentOptions, loadEmploymentDone])

  return (
    <FormPadding isSubForm={window.screen.width < 800} customStyle={css({paddingLeft: '0px'})}>
    <FormPadding>
      <Row css={css({ alignItems: 'baseline !important' })}>
          <Col md={2} lg={1}>
            <div css={css({ marginTop: "18px" })}>
              <BodyText>期間</BodyText>
            </div>
          </Col>
          <Col md={10} lg={11}>
          <FlexBox>
            <Col md={5} lg={3}>
              <FlexBox>
                <FlexBoxItem>
                  <Calendar 
                    openActionChevron={true}
                    date={moment(dateFromStr).toDate()}
                    setDate={(date) => {
                     if(date){
                      let newdate = date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
                      setDateFromStr(newdate);
                      sessionStorage.setItem("attendStampList.dailyShift.targetDateFrom", newdate);
                     }
                    }}
                  />
                </FlexBoxItem>
                {/* <FlexBoxItem customStyle={css({ marginLeft: '-35px' })}>
                  <ClickableIconButton onClick={() => {
                    const prevDate = moment(dateFromStr).subtract(1, 'day').format('YYYY-MM-DD');
                    setDateFromStr(prevDate);
                    sessionStorage.setItem('attendStampList.dailyShift.targetDateFrom', prevDate);
                  }}>
                    <Icon type="chevronLeft" color="" size="24px" />
                  </ClickableIconButton>
                </FlexBoxItem>
                <FlexBoxItem>
                  <CalendarForm
                    label=""
                    date={moment(dateFromStr).toDate()}
                    dateFormat="YYYY/MM/DD"
                    changeDate={(date: Date) => {
                      let newdate = date ? moment(date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
                      setDateFromStr(newdate);
                      sessionStorage.setItem("attendStampList.dailyShift.targetDateFrom", newdate);
                    }}
                  />
                </FlexBoxItem>
                <FlexBoxItem>
                  <ClickableIconButton onClick={() => {
                    const nextDate = moment(dateFromStr).add(1, 'day').format('YYYY-MM-DD');
                    setDateFromStr(nextDate);
                    sessionStorage.setItem('attendStampList.dailyShift.targetDateFrom', nextDate);
                  }}>
                    <Icon type="chevronRight" color="" size="24px" />
                  </ClickableIconButton>
                </FlexBoxItem> */}
              </FlexBox>
            </Col>
            <Col md={9} lg={9}>
              <div css={css({ display: "flex", alignItems: "baseline", marginLeft: "20px", marginTop: "-8px" })}>
                <Checkbox
                  id="1"
                  name="isAttendExists"
                  label="シフト・実績有る人のみ表示"
                  value={"1"}
                  checked={isAttendExists === "1" ? true : false}
                  onChange={() => {
                    sessionStorage.setItem("attendStampList.attendFlag", isAttendExists === "1" ? "0" : "1")
                    setAttendExists(isAttendExists === "1" ? "0" : "1");
                  }}
                />
              </div>
            </Col>
          </FlexBox>
        </Col>
      </Row>
    </FormPadding>
      <FormPadding>
        <Row>
          <Col lg={1} md={2} css={css({ display: 'flex', alignItems: 'center'})}>
            <div>
              <BodyText>組織</BodyText>
            </div>
          </Col>
          <Col lg={3} md={3}>
            <div css={css({ width: '480px'}, 
              css`
                @media only screen and (min-width : 768px) {
                  width: calc(100% + 265px);
                }
              `
              )}>
              <SelectForm
                label=""
                name="attendEmployment"
                value={selectedOrg}
                setValue={(orgCode) => {
                  setSelectedOrg(orgCode);
                  sessionStorage.setItem("attendStampList.dailyShift.orgCode", orgCode);
                }}
                options={orgs}
                zIndex={1}
                ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgs.length === 1)}
              />
            </div>
          </Col>
        </Row>
      </FormPadding>

      <FormPadding>
        <Row>
          <Col lg={1} md={2}>
            <div css={css({ marginTop: "8px" })}>
              <BodyText>雇用形態</BodyText>
            </div>
          </Col>
          <Col lg={11} md={10} css={css({ display: "flex", flexWrap: "wrap" })}>
            <div css={css({ padding: "8px 10px 5px 0" })}>
              <Checkbox
                id={"all"}
                name={"checkall"}
                label="すべて"
                value={"1"}
                checked={checkall}
                onChange={(event) => {
                  let newEmploymentOptions = employmentOptions.map((option) => {
                    option.checked = !checkall;
                    return option;
                  });
                  setEmploymentOptions(newEmploymentOptions);
                  setCheckall(!checkall);
                }}
              />
            </div>
            {employmentOptions.map((option, key) => {
              return (
                <div key={key} css={css({ padding: "8px 10px 5px 0" })}>
                  <Checkbox
                    customStyleLabel={css({ 
                      maxWidth: '250px',
                      overflow: 'hidden',
                      display: 'block',
                      textOverflow: 'ellipsis'
                    })}
                    id={option.id}
                    name={option.label}
                    label={option.label}
                    value={option.value}
                    checked={option.checked}
                    onChange={(event) => {
                      let newEmploymentOptions = [...employmentOptions];
                      newEmploymentOptions[key].checked = event.target.checked;
                      setEmploymentOptions(newEmploymentOptions);
                    }}
                  />
                </div>
              );
            })}
          </Col>
        </Row>
      </FormPadding>
      <Row>
        <FlexBox customStyle={css({ margin: "1rem 0", width: "100%", justifyContent: "flex-end" })}>
          {dailyShift?.isShiftConfirm ? (
            <SecondaryButton
              text="シフト確定解除"
              onClick={() => {
                setOpenConfirmModal(true);
              }}
            />
          ) : (
            <PrimaryButton
              text="シフト確定"
              disabled={dailyShift.isAchievementConfirm || dailyShift.isShiftConfirm}
              onClick={() => {
                setOpenConfirmModal(true);
              }}
            />
          )}
          <ClickableIconButton onClick={downloadPdf} additionalCss={css({ margin: "0 0 0 10px", cursor: "pointer" })}>
            <span className="print">
              <Icon type="printer" color="" size="24px" />
            </span>
          </ClickableIconButton>
        </FlexBox>
      </Row>
    </FormPadding>
  );
};

export default Filters;
